export default function TeamHeads(teamId) {
    return "/login_notification.png";
}